import styled from "styled-components";

export const ArticleInfoWrapper = styled.div`
  padding: 10px;
  color: ${({ theme }) => theme.colors.textColor};

  display: flex;
  flex-direction: column;
  justify-content: center;
`;
